<div class="search-box">
  <i class="fas fa-search" aria-hidden="true" style="color: #5E6980"></i>
  <input [ngStyle]="{'width': width}" #input [id]="'beaconstac-search-' + id" class="ng-untouched ng-pristine ng-valid" [value]="text" placeholder="{{searchPlaceholder}}" type="text">
</div>
